<template>
  <div>
    <el-dialog
      :title="$t('lang.电表刷新')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="1000px"
    >
      <div class="refresh_box">
        <div>
          <span>{{ $t("lang.总用电量") }}</span>
          <span>{{ $t("lang.拉合闸状态") }}</span>
          <span :style="{ flex: isThreePhase ? '2' : '1' }">
            {{ $t("lang.电压") }}
          </span>
          <span :style="{ flex: isThreePhase ? '2' : '1' }">
            {{ $t("lang.电流") }}
          </span>
          <span>{{ $t("lang.功率因数") }}</span>
        </div>
        <div>
          <span>{{ deviceMessage.ZYBM | isKwh }}</span>
          <span>{{ isElectricity(deviceMessage.CtrlStatus) }}</span>
          <span v-if="!isThreePhase">{{ deviceMessage.Ua | isV }}</span>
          <span v-if="!isThreePhase">{{ deviceMessage.Ia | isA }}</span>
          <span v-if="isThreePhase" :style="{ flex: isThreePhase ? '2' : '1' }">
            <i>A:{{ deviceMessage.Ua }}V</i>
            <i>B:{{ deviceMessage.Ub }}V</i>
            <i>C:{{ deviceMessage.Uc }}V</i>
          </span>
          <span v-if="isThreePhase" :style="{ flex: isThreePhase ? '2' : '1' }">
            <i>A:{{ deviceMessage.Ia }}A</i>
            <i>B:{{ deviceMessage.Ib }}A</i>
            <i>C:{{ deviceMessage.Ic }}A</i>
          </span>
          <span>{{ deviceMessage.PF || "--" }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t("lang.取消") }}
        </el-button>
        <el-button type="primary" @click="onClickRefresh">
          {{ $t("lang.刷新") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  inject: ["equipmentPage"],
  data() {
    return {
      dialogVisible: false,
      pointId: "",
      deviceMessage: "",
      /**是否为三相表 */
      isThreePhase: false,
    };
  },
  filters: {
    isKwh(val) {
      if (val === undefined || val === null || val === "") return "--";
      return val + "kW·h";
    },
    isV(val) {
      if (val === undefined || val === null || val === "") return "--";
      return val + "V";
    },
    isA(val) {
      if (val === undefined || val === null || val === "") return "--";
      return val + "A";
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      deviceRefresh: "ZD_DeviceRefresh",
    }),
    async showDialog(pointId) {
      this.dialogVisible = true;
      this.pointId = pointId;
      this.deviceMessage = "";
      this.isThreePhase = false;
      this.onClickRefresh();
    },
    async onClickRefresh() {
      let fullScreenLoading = this.$loading({
        lock: true,
        text: this.$t("lang.加载中"),
        spinner: "el-icon-loading font34",
        background: "rgba(255, 255, 255, 0.5)",
        customClass: "myLoading",
      });
      try {
        let res = await this.deviceRefresh({
          pointId: this.pointId,
          successCheckType: 1,
        });
        if (res.success !== 1) throw new Error("");
        let data = JSON.parse(res.message);
        this.deviceMessage = data;
        this.isThreePhase = data.Ub == undefined ? false : true;
        this.$parent.isThreePhase = data.Ub == undefined ? false : true;
        this.$parent.voltage = data.Ua + "V";
        this.$parent.current = data.Ia + "A";
        if (!this.isnull(data.SSID)) {
          this.$parent.wifiAccount = data.SSID.split(",")[0];
          this.$parent.wifiPassword = data.SSID.split(",")[1];
        }
        this.$parent.deviceData.dataTime = data.DataTime;
        this.$parent.deviceData.status = data.CtrlStatus;
        this.$parent.readingData = data;
        this.$message({
          message: this.$t("lang.刷新成功"),
          type: "success",
        });
      } catch (e){
        console.log('报错>>',e)
        this.$message({
          message: this.$t("lang.刷新失败"),
          type: "error",
        });
      } finally {
        fullScreenLoading.close();
      }
    },
    isElectricity(val) {
      if (val === undefined || val === null || val === "") return "--";
      switch (val) {
        case "0":
          return this.$t("lang.断电");
        case "1":
          return this.$t("lang.通电");
        case "-1":
          return this.$t("lang.离线");
        default:
          return "--";
      }
    },
  },
};
</script>

<style scoped lang='less'>
/deep/ .el-dialog {
  margin-top: 42vh !important;
}
/deep/ .el-dialog__body {
  padding: 30px 45px;
}
.refresh_box {
  div {
    display: flex;
    height: 34px;
    line-height: 34px;
    color: #999;
    font-size: 16px;
    margin-bottom: 10px;
    span {
      flex: 1;
      text-align: center;
      i {
        font-style: normal;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  div:first-child span {
    line-height: 18px;
  }
  div:last-child {
    background: #eef4fa;
    color: #333;
    margin-bottom: 0;
  }
}
.font34 {
  font-size: 34px;
}
</style>
<style>
.myLoading {
  z-index: 9999 !important;
}
</style>